{
  "checks": {
    "chip": {
      "fail_one": "Prüfungen: {{count}} schlägt fehl",
      "fail_other": "Prüfungen: {{count}} schlagen fehl",
      "failed": "Prüfungen: nicht ladbar",
      "hint": "Schlussfolgern, Konsistenz, Shapes und Kompetenzfragen, auf dieser Version ausgeführt",
      "notChecked_one": "Prüfungen: {{count}} nicht geprüft",
      "notChecked_other": "Prüfungen: {{count}} nicht geprüft",
      "notRun": "Prüfungen: nicht gelaufen",
      "pass": "Prüfungen: alle bestanden",
      "running": "Prüfungen: laufen…"
    },
    "close": "Prüfungen schließen",
    "failsHere": "Hier schlägt eine Prüfung fehl",
    "process": "Prozessprüfungen",
    "running": "Die Prüfungen laufen…",
    "title": "Prüfungen"
  },
  "children": "Untergeordnet",
  "chooseVersion": "Version wählen …",
  "collapseEntity": "{{name}} zuklappen",
  "copyModule": "Genaue Referenz dieses Ontologiemoduls kopieren",
  "cycleReference": "Zyklus",
  "declaredIn": "Im Ontologiemodul",
  "definitions": "Definitionen",
  "details": "Details",
  "displayMode": "Ansicht",
  "domain": "Gilt für (Domain)",
  "empty": {
    "body": "Diese Version hat kein Ontologiemodul. Ihre Begriffe erscheinen hier, sobald ein Änderungssatz eines hinzufügt.",
    "inherits": "Dieses Projekt hat noch kein eigenes Ontologiemodul.",
    "title": "Noch kein Datenmodell"
  },
  "entityTypeChoice": "Art der Entität",
  "entityTypeHints": {
    "annotationProperties": "Angaben zu Begriffen, etwa Bezeichnungen und Definitionen",
    "classes": "Arten von Dingen, vom Allgemeinen zum Besonderen",
    "dataProperties": "Werte, die ein Ding hat, etwa ein Datum oder ein Name",
    "individuals": "Einzelne benannte Dinge, die das Datenmodell selbst festlegt, etwa feste Werte",
    "objectProperties": "Wie ein Ding mit einem anderen zusammenhängt",
    "relations": "Welche Klassen die Objekteigenschaften verbinden"
  },
  "entityTypes": {
    "annotationProperties": "Annotationseigenschaften",
    "classes": "Klassen",
    "dataProperties": "Dateneigenschaften",
    "individuals": "Benannte Individuen",
    "objectProperties": "Objekteigenschaften",
    "relations": "Relationsübersicht"
  },
  "exactReference": "Genaue Referenz dieser Version kopieren",
  "expandEntity": "{{name}} aufklappen",
  "incomingRelations": "Eingehende Relationen",
  "labels": "Bezeichnungen",
  "latestVersion": "Neueste Version",
  "loading": "Ontologie wird geladen …",
  "loadingTerm": "Begriff wird geladen …",
  "loadingVersions": "Versionen werden geladen …",
  "modules": {
    "all": "Alle ({{count}})",
    "allHint": "Die Begriffe der eigenen Ontologiemodule des Projekts zeigen",
    "dmwBasis": "DMW-Basis",
    "library": "Festgelegte Bibliothek",
    "none": "Diese Version hat kein Ontologiemodul.",
    "title": "Ontologiemodule",
    "turtleOf": "Turtle des Ontologiemoduls {{name}}"
  },
  "noChildren": "Nichts untergeordnet.",
  "noDefinitions": "Keine Definitionen.",
  "noDomain": "Nicht eingeschränkt.",
  "noEntities": "Keine Einträge gefunden.",
  "noEntitySelected": "Nichts ausgewählt.",
  "noIncomingRelations": "Keine eingehenden Relationen.",
  "noLabels": "Keine Bezeichnungen.",
  "noOutgoingRelations": "Keine ausgehenden Relationen.",
  "noParents": "Nichts übergeordnet.",
  "noProjectBody": "Die Ontologie gehört zu einem Projekt. Wählen Sie eines in der oberen Leiste.",
  "noProjectTitle": "Zuerst ein Projekt wählen",
  "noRange": "Nicht eingeschränkt.",
  "noVersionBody": "Dieses Projekt hat noch keine Ontologie-Version.",
  "noVersionTitle": "Noch keine Ontologie-Version",
  "olderVersion": "Ältere Version, nur lesbar",
  "openEntity": "{{name}} öffnen",
  "outgoingRelations": "Ausgehende Relationen",
  "pages": {"release": "Veröffentlichung", "result": "Ergebnis"},
  "parents": "Übergeordnet",
  "predicates": {
    "altLabel": "weitere Bezeichnung",
    "comment": "comment",
    "definition": "definition",
    "editorialNote": "redaktionelle Notiz",
    "hiddenLabel": "verborgene Bezeichnung",
    "label": "Bezeichnung",
    "prefLabel": "bevorzugte Bezeichnung",
    "scopeNote": "Anwendungshinweis"
  },
  "proposals": {
    "addDefinition": "Definition hinzufügen",
    "addLabel": "Bezeichnung hinzufügen",
    "addSubclass": "Unterklasse hinzufügen",
    "definitionText": "Definition",
    "existingChangeSet": "Zu einem meiner offenen Änderungssätze hinzufügen",
    "labelText": "Bezeichnung",
    "language": "Sprache",
    "languageHint": "Ein Sprachkürzel wie en oder de; leer lassen für keine.",
    "latestOnly": "Änderungen werden auf der neuesten Version vorgeschlagen. Wechseln Sie dorthin, um eine vorzuschlagen.",
    "newChangeSet": "Neuer Änderungssatz",
    "newIri": "IRI der neuen Klasse",
    "noOpenChangeSets": "Sie haben in diesem Projekt keinen offenen Änderungssatz.",
    "othersChangeSets": "Änderungssätze anderer (als Kuratorin oder Kurator)",
    "ownChangeSets": "Meine Änderungssätze",
    "preview": "Was sich ändert",
    "problems": {
      "empty": "Geben Sie einen Text ein.",
      "iri": "Geben Sie eine absolute IRI ohne Leerzeichen ein, etwa http://example.org/terms#Abbot.",
      "iriTaken": "Einen Begriff mit dieser IRI gibt es schon.",
      "language": "Das ist kein gültiges Sprachkürzel.",
      "unchanged": "Der Text ist unverändert."
    },
    "propose": "Vorschlagen",
    "subtitle": "Ihre Änderung wird Teil eines Änderungssatzes. Kuratierende sehen ihn im Review durch, bevor er in die Ontologie übernommen wird.",
    "target": "Änderungssatz",
    "title": "Titel des Änderungssatzes",
    "titles": {
      "addLabel": "Bezeichnung zu {{name}} hinzufügen",
      "addSubclass": "Unterklasse von {{name}} hinzufügen",
      "editDefinition": "Definition von {{name}} bearbeiten",
      "edits": "{{name}} bearbeiten",
      "renameLabel": "Eine Bezeichnung von {{name}} umbenennen"
    }
  },
  "range": "Werte (Range)",
  "raw": "Turtle (Rohtext)",
  "relationProperty": "Beziehung: {{name}}",
  "relationSource": "von",
  "relationTarget": "zu",
  "releases": {
    "count_one": "{{count}} Veröffentlichung",
    "count_other": "{{count}} Veröffentlichungen"
  },
  "resizePanels": "Hierarchie und Details in der Größe anpassen",
  "restrictions": {
    "axioms": {
      "equivalent_class": "Etwas ist genau dann {{name}}, wenn es …",
      "subclass_of": "Jede(r) {{name}} …"
    },
    "classExpression": "einen verschachtelten Klassenausdruck (siehe Turtle unten)",
    "constraints": {
      "all_values_from": "nur",
      "exact_cardinality": "genau {{count}}",
      "has_value": "den Wert",
      "max_cardinality": "höchstens {{count}}",
      "min_cardinality": "mindestens {{count}}",
      "some_values_from": "mindestens ein(e)"
    },
    "none": "Keine Einschränkungen.",
    "title": "Einschränkungen",
    "values": "Werte"
  },
  "search": {
    "label": "Begriff finden",
    "none": "Kein Begriff passt.",
    "placeholder": "Bezeichnung oder IRI",
    "searching": "Suche läuft …"
  },
  "slice": {
    "close": "Ganzes Datenmodell zeigen",
    "editInReview": "Im Review bearbeiten",
    "loading": "Ausschnitt wird geladen…",
    "missingBody": "Der Link nennt einen Durchlauf-Eintrag ohne Ontologiebegriffe, oder der Durchlauf ist nicht lesbar.",
    "missingTitle": "Hier ist kein Ausschnitt",
    "now": "Datenmodell jetzt",
    "of_one": "{{count}} Begriff des Ausschnitts aus",
    "of_other": "{{count}} Begriffe des Ausschnitts aus",
    "proposed": "Wie vorgeschlagen",
    "wholeBeside": "Ganzes Datenmodell daneben"
  },
  "structured": "Strukturiert",
  "termKinds": {
    "annotation_property": "Annotationseigenschaft",
    "class": "Klasse",
    "datatype_property": "Dateneigenschaft",
    "individual": "Benanntes Individuum",
    "object_property": "Objekteigenschaft"
  },
  "termTurtle": "Turtle dieses Begriffs",
  "title": "Datenmodell",
  "usage": {
    "inTheData": "In den Daten",
    "none": "In dieser Version verwendet nichts diesen Begriff.",
    "title": "Wo er verwendet wird",
    "via": "über"
  },
  "version": "Version",
  "versions": "Versionen"
}
